/**
 * allow upload file with these types
 * */
export const allowedFileTypesToUpload = [
  "image/*",
  "video/*",
  "audio/*",
  "application/pdf",
  ".doc",
  ".docx",
  // ".xls",
  // ".xlsx",
  ".MTS",
  ".mts",
  ".m4v",
  ".M4V",
  ".vob",
  ".VOB",
  ".avi",
  ".AVI",
  ".mkv",
  ".MKV"
] as const;
